import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0;
  
  @media (max-width: 1440px) {
    display: none;
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  box-shadow: ${props => props.theme.shadows.primary};
  border-radius: 0 0 ${props => props.theme.radius.primary} ${props => props.theme.radius.primary};
  padding: 1.5rem;

  .react-calendar {
    position: relative;

    abbr {
      text-decoration: none !important;
      text-transform: uppercase !important;
      font-size: 0.8rem !important;
      font-weight: 600 !important;
    }
  }

  .react-calendar__navigation {
    border: none;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }

  .react-calendar__month-view__weekdays {
    text-align: center;
    background: ${props => props.theme.cards.tertiary};
    margin-bottom: 1rem;
    border-radius: 50px;
    padding: 0.5rem 0;
  }

  .react-calendar__tile {
    border: none;
    background: none;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 0;
    border-radius: 50% !important;
    transition: background-color 0.2s ease;

    &:not(.event-date) {
      color: ${props => props.theme.colors.white} !important;
    }
  }

  .react-calendar__month-view__days__day {
    color: ${props => props.theme.colors.white} !important;
    font-weight: 700;
    width: 50px !important;
    height: 50px !important;
  }

  .react-calendar__month-view__days__day--neighboringMonth {
    color: ${props => props.theme.colors.muted}80 !important;
    font-weight: 400;
  }

  .react-calendar__tile--active {
    background: ${props => props.theme.colors.tertiary} !important;
    color: ${props => props.theme.colors.white} !important;
    background: none !important;

    &:not(.event-date) {
      
      color: ${props => props.theme.colors.white} !important;
    }

    &.react-calendar__tile--active {
      background: none;

      > abbr {
        color: ${props => props.theme.colors.white};
      }
    }
  }

  .react-calendar__tile--active > abbr {
    color: ${props => props.theme.colors.dark};
  }

  .event-date {
    position: relative;
    transition: all ease-in-out 0.25s;

    &:hover {
      background: ${props => props.theme.cards.tertiary};
      color: ${props => props.theme.colors.white};
      border-radius: 50%;
      cursor: pointer;
    }

    &:after {
      content: '';
      position: absolute;
      width: 5px;
      height: 5px;
      background: ${props => props.theme.colors.primary};
      border-radius: 50%;
      right: calc(50% - 2.5px);
      bottom: 6px;
    }
  }

  .is-today {
    background: ${props => props.theme.colors.primary} !important;
    
    > abbr {
      color: #3e3f5e !important;
    }
  }
`;

export const Header = styled.header`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1rem 1.5rem;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  border-bottom: none;
  border-radius: 24px 24px 0 0;

  > div {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    align-items: flex-start;

    > h2 {
      font-size: 1rem;
      font-weight: 700;
    }

    > h5 {
      color: ${props => props.theme.colors.muted};
      font-size: 12px;
      font-weight: 400;
    }
  }
  

  > aside {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: center;

    > button {
      background: none;
      border: none;
      color: ${props => props.theme.colors.white};
      font-size: 1rem;
      font-weight: 600;
      cursor: pointer;
      transition: color 0.2s;
      padding: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        color: ${props => props.theme.colors.primary};
        background: ${props => props.theme.cards.tertiary};
        border-radius: 50%;
      }
    }
  }
`;
